// extracted by mini-css-extract-plugin
module.exports = {"menu-color":"rgba(255,255,255,0.95)","menu-color-active":"rgba(255,255,255,0.95)","menu-background":"#2f3447"};